import { Popover } from '@byecode/ui'
import type { Shadow } from '@lighthouse/core'
import { BACKGROUND_TYPE } from '@lighthouse/core'
import { FilledInput, PopoverDropdownWithClose, ShadowController } from '@lighthouse/shared'
import isDeepEqual from 'fast-deep-equal'
import React from 'react'

import { useColorSystemAction } from '@/hooks/useColorSystemAction'
import { useGetColorVariableOptions } from '@/hooks/useGetColorVariableOptions'

interface ShadowFieldProps {
    value: Shadow | undefined
    onChange: (val: Shadow) => void

    customViewDsId?: string
    // prefixPath?: string
    // onSetBreakKey?: (name: string) => void
}

export const ShadowField: React.FC<ShadowFieldProps> = ({ value, onChange, customViewDsId }) => {
    // const { control, setValue, getValues } = useFormContext<ContainerBlockConfig>()
    const colorSystemMethods = useColorSystemAction()
    // const shadowName = combinePath(prefixPath, 'breakPoint.design.shadow')

    const variableTypeOption = useGetColorVariableOptions({
        customViewDsId
    })

    return (
        <Popover
            width={300}
            position="left-start"
            withinPortal
            autoUpdate={false}
            offsetOptions={168}
            onOpen={() => {
                if (!value?.color) {
                    onChange({
                        color: '#00000040',
                        x: 0,
                        y: 4,
                        blur: 4,
                        diffusion: 4
                    })
                }
            }}
        >
            <Popover.Target>
                <FilledInput
                    value={{ type: BACKGROUND_TYPE.color, color: value?.color }}
                    onClear={() => {
                        onChange({
                            color: '',
                            x: 0,
                            y: 0,
                            blur: 0,
                            diffusion: 0
                        })
                    }}
                    style={{ width: 180 }}
                    // variableTypeOption={variableTypeOption}
                />
            </Popover.Target>
            <PopoverDropdownWithClose title="阴影">
                <ShadowController
                    value={value}
                    onChange={val => {
                        if (isDeepEqual(val, value)) {
                            return
                        }
                        onChange(val)
                    }}
                    // variableTypeOption={variableTypeOption}
                    {...colorSystemMethods}
                />
            </PopoverDropdownWithClose>
        </Popover>
    )
}
